import { CircularProgress, List, ListItemButton, ListItemText } from "@mui/material";
import React, { useContext } from "react";

import { AutocompleteContext } from "../contexts";

export const Listbox = React.forwardRef<HTMLUListElement, React.PropsWithChildren<React.HTMLAttributes<HTMLElement>>>(
  (props, ref) => {
    const { hasMoreOptions, fetchNextPage, isLoadingOptions } = useContext(AutocompleteContext);

    return (
      <List {...props} ref={ref}>
        {props.children}

        {hasMoreOptions && (
          <ListItemButton
            onClick={fetchNextPage}
            disabled={isLoadingOptions}
            className="flex justify-center items-center"
          >
            {isLoadingOptions ? (
              <CircularProgress size={20} />
            ) : (
                <ListItemText className="text-primary-dark">
                Load more
              </ListItemText>
            )}
          </ListItemButton>
        )}
      </List>
    );
  }
);
